<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img
        src="https://wikipapa.org/images/banner-inicio-catalogo.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 15%'"
      [style.background-color]="'#fff8e0'"
    >
      <div fxFlex="100%">
        <p class="p1">
          <span class="b1">Es la recopilación de diversos catálogos</span>
          trabajos a lo largo de diferentes años con CIP y colaboradores como
          Yanapai, AGUAPAN, PATAZ y los gobiernos regionales de Huancavelica, Junín y
          La Libertad
        </p>
      </div>
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around"
      [style.padding]="'10% 15%'"
      [style.background-color]="'#ffffff'"
    >
      <div fxFlex="27.5%">
        <img
          src="https://wikipapa.org/images/circulo1-catalogo.jpg"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>
      <div
        style="
          border: solid 2px #ff735c;
          margin-top: 30%;
          width: 2px;
          background-color: #ff735c;
        "
      ></div>
      <div fxFlex="27.5%">
        <img
          src="https://wikipapa.org/images/circulo2-catalogo.jpg"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>

      <div
        style="
          border: solid 2px #ff735c;
          margin-top: 30%;
          width: 2px;
          background-color: #ff735c;
        "
      ></div>

      <div fxFlex="27.5%">
        <img
          src="https://wikipapa.org/images/circulo3-catalogo.jpg"
          style="object-fit: contain; background-size: cover"
          width="100%"
        />
      </div>
    </div>

    <!-- <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.padding]="'0% 15%'"
      [style.background-color]="'#FFEFA9'"
    >
      <div fxFlex="100%">
        <p class="p1">
          <span class="b1">Es la recopilación de diversos catálogos</span>
          trabajos a lo largo de diferentes años con CIP y colaboradores como
          Yanapai y AGUAPAN y los gobiernos regionales de Huancavelica, Junín y
          La Libertad
        </p>
      </div>
    </div> -->
  </div>
</div>
